module.exports = __webpack_public_path__ + "static/img/multiresidential.1868732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/multiresidential.jpg
// module id = 4i2w
// module chunks = 0